import { language } from '@tencent/ppd-base-libs';
import zhCnConfig from '../i18n/zh-cn/main.json';
import enConfig from '../i18n/en/main.json';
import zhHkConfig from '../i18n/zh-hk/main.json';
let langConfig = zhHkConfig; // 默认语言

/**
 * 语言map
 */
const langMap = {
    'zh-hk': zhHkConfig,
    'zh-cn': zhCnConfig,
    en: enConfig,
};

/**
 * 初始化配置
 */
function init(): void {
    const lang = language.getLanguage();
    if (langMap[lang]) {
        langConfig = langMap[lang];
    } else {
        // if(Production) {
        // 缺少该语言 上报但不堵塞流程
        // new CustomException(lang, '缺少语言');
        // }
    }
}
export function i18n(key: string, data?: object) {
    let value = langConfig[key];
    if (data) {
        // 说明有要替换的
        value = value.replace(/{{([^}]+)}}/g, (...arg) => {
            const replaceKey = arg[1];
            return data[replaceKey];
        });
        return value;
    }
    if (!value) {
        // if(Production) {
        // 缺少语言配置 上报 不堵塞流程
        // new CustomException(key, '缺少语言key');
        // }
        return key;
    }
    return value;
}
export const install = {
    install: (Vue) => {
        Vue.prototype.i = function (key) {
            return i18n(key);
        };
        Vue.prototype.$tc = function (key) {
            return i18n(key) || key;
        };
    },
};

init();
